// extracted by mini-css-extract-plugin
export default {"welcome-heading":"adminHeader_welcome-heading__5v35i","saved-heading":"adminHeader_saved-heading__C0Iuh","unsaved-heading":"adminHeader_unsaved-heading__WjX+p"};